<template>
  <div>
    <template v-if="type === 'phone'">
      <v-btn class="mx-1" icon @click="whatsapp(value, message)">
        <v-icon size="20">
          mdi-whatsapp
        </v-icon>
      </v-btn>
      <v-btn class="mx-1" icon @click="call(value)">
        <v-icon size="19">
          mdi-phone
        </v-icon>
      </v-btn>
    </template>
    <template v-if="type === 'email'">
      <v-btn class="mx-1" icon @click="email(value, { subject, message })">
        <v-icon size="20">
          mdi-email
        </v-icon>
      </v-btn>
    </template>
    <v-btn class="mx-1" icon @click="copyToClipboard(value)">
      <v-icon size="20">
        mdi-content-copy
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "toolTipContact",
  props: {
    type: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    message: {
      type: String,
      required: false
    },
    subject: {
      type: String,
      required: false
    }
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
    },
    call(phone) {
      window.open(`tel://${phone}`, "_blank");
    },
    whatsapp(phone, message) {
      window.open(
        `//api.whatsapp.com/send?phone=+${phone}&text=+${message}`,
        "_blank"
      );
    },
    email(email, { subject, body }) {
      const url = encodeURI(`mailto:${email}?subject=${subject}&body=${body}`);
      window.open(url, "_blank");
    }
  }
};
</script>
<style scoped></style>
